import React, { useCallback } from 'react';
import * as Sentry from '@sentry/react';
import moment from 'moment';

import { useI18n } from '../../../../../data/hooks/i18nHooks';
import RatingInput from '../../../../elements/forms/RatingInput';
import styles from './RateScheduleItem.module.scss';

const RateScheduleItem = (props) => {
    const { event, session } = props,
        i18n = useI18n(),
        isRateOpen = (!event.rate_open_date || moment().isAfter(event.rate_open_date)) && (!event.rate_close_date || moment().isBefore(event.rate_close_date)),
        rateEnabled = event.joined && isRateOpen && (session.is_selected || !session.is_selectable);

    const handleAnswerChange = useCallback(
        (rating) => {
            app.api.events.rateProgramItem(event.id, session.id, rating).catch((err) => {
                Sentry.captureException(err);
            });
        },
        [event]
    );

    if (!event.rate_enabled || !session.rate_enabled) return null;

    return (
        <>
            <hr style={{ borderTop: `1px solid ${event.settings.primary_color}` }} />
            <div className="content">
                <div className={[styles.RateScheduleItem, rateEnabled ? '' : styles.disabled].join(' ')}>
                    <h3 className={[styles.title, rateEnabled ? '' : styles.disabled].join(' ')}>{session.rate_question || i18n['label.rate']}</h3>
                    <RatingInput value={session.rate_mine} maxRating={5} checkedColor={event.settings.primary_color} onChange={handleAnswerChange} disabled={!rateEnabled} />
                </div>
            </div>
            {session.rate_mine && event.rate_results_visible && session.rate_average ? (
                <>
                    <hr style={{ borderTop: `1px solid ${event.settings.primary_color}` }} />
                    <div className={[styles.RateScheduleItem, styles.average].join(' ')}>
                        <h3 className={[styles.title].join(' ')}>{i18n['label.total-rating']}</h3>
                        <RatingInput value={Math.round(session.rate_average)} maxRating={5} checkedColor={event.settings.primary_color} />
                        <p>
                            {session.rate_count} {session.rate_count == 1 ? i18n['label.rate-vote'] : i18n['label.rate-votes']}
                        </p>
                    </div>
                    <hr style={{ borderTop: `1px solid ${event.settings.primary_color}` }} />
                </>
            ) : null}
        </>
    );
};

export default RateScheduleItem;
